// @flow
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { createUseStyles } from 'react-jss';

type Props = {
  show: boolean,
  children: React.Element<any> | React.Element<any>[]
}

const useStyles = createUseStyles({
  transition: {
    opacity: '0',
    transform: 'translateX(-7%)',
    '&.transition-enter': {
      opacity: '0',
      transform: 'translateX(-7%)'
    },
    '&.transition-enter-active, &.transition-enter-done': {
      opacity: '1',
      transform: 'none',
      transition: 'opacity, transform',
      transitionDuration: '.6s',
      transitionDelay: '.1s',
      transitionTimingFunction: 'ease-in'
    }
  }
});

const SlideRightFadeIn = (props: Props) => {
  const { children, show = true } = props;
  const c = useStyles();

  return (
    <CSSTransition
      in={show}
      classNames="transition"
      timeout={{ enter: 1200 }}
    >
      <div className={c.transition}>
        {children}
      </div>
    </CSSTransition>
  );
};

export default SlideRightFadeIn;
